import axios from "axios";
//添加发票
export const addInvoice = (data) => axios.post("/api/web/bill/add", data);
//查询中奖
export const getbill = (data) =>
    axios.get(`/api/web/bill/phone/${data.drawLotteryId}&${data.phone}`);
//查询活动
export const getAct = () => axios.get("/api/web/billDrawLottery/all");
//获取发票配置
export const getConfig = () => axios.get("/api/web/billConfig");